import { useEffect, useState } from "react";
import CustomSelect from "../CustomSelect/CustomSelect";
import "./styles.scss";

export const PAGE_SIZE_OPTIONS = [10, 15, 25, 50];

const storageKey = (tableName) => `${tableName}PageSize`;

// 10 / 15 / 25 / 50, plus the table's own default when it is something else (a
// popup that shows 200 rows keeps that option)
export const getPageSizeOptions = (defaultSize) =>
  [...new Set([...PAGE_SIZE_OPTIONS, defaultSize])]
    .filter((size) => Number.isInteger(size) && size > 0)
    .sort((a, b) => a - b);

// Remembered per table name, like the "Filter by last" selection
export const getStoredPageSize = (tableName, defaultSize) => {
  if (!tableName) return defaultSize;
  try {
    const stored = Number(localStorage.getItem(storageKey(tableName)));
    return getPageSizeOptions(defaultSize).includes(stored) ? stored : defaultSize;
  } catch (e) {
    return defaultSize;
  }
};

export const storePageSize = (tableName, size) => {
  if (!tableName) return;
  try {
    localStorage.setItem(storageKey(tableName), String(size));
  } catch (e) {
    // Storage can be unavailable (private mode); the choice then lasts until reload
  }
};

export const usePageSize = (tableName, defaultSize) => {
  const [pageSize, setPageSize] = useState(() => getStoredPageSize(tableName, defaultSize));

  // One table instance can switch between tables (dashboard tabs)
  useEffect(() => {
    setPageSize(getStoredPageSize(tableName, defaultSize));
  }, [tableName, defaultSize]);

  const changePageSize = (size) => {
    setPageSize(size);
    storePageSize(tableName, size);
  };

  return [pageSize, changePageSize];
};

const PageSizeSelect = ({ value, defaultSize, onChange }) => {
  const options = getPageSizeOptions(defaultSize).map((size) => ({
    id: size,
    value: String(size),
  }));

  return (
    <div className="page-size-select">
      <p>Rows per page:</p>
      <CustomSelect
        data={options}
        select={{ id: value, value: String(value) }}
        setSelected={(item) => item.id !== value && onChange(item.id)}
        width="64px"
        height="26px"
      />
    </div>
  );
};

export default PageSizeSelect;
